import { render } from "./ProgramMultimediaListAndEditItemView.vue?vue&type=template&id=0596b28c&scoped=true&ts=true"
import script from "./ProgramMultimediaListAndEditItemView.vue?vue&type=script&lang=ts"
export * from "./ProgramMultimediaListAndEditItemView.vue?vue&type=script&lang=ts"

import "./ProgramMultimediaListAndEditItemView.vue?vue&type=style&index=0&id=0596b28c&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0596b28c"]])

export default __exports__